// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import cstmTable from '../../../../share/components/vue/PaginationTable';
import error from '../../../../common/nodejs/errors';
import config from '../../../../share/config';
import session from '../../../../share/session';

/** 各フェーズ定義 */
const PHASE = {
  IN_PROGRESS: 'inProgress',
  RESULT: 'result',
  FAILED: 'failed',
  ERROR: 'error',
  ERROR_COMMUNICATION: 'communicationError',
  ERROR_FACTOR: 'errorFactor',
};

/** 読出しデータ判別 */
const DATA_RECORD = {
  DATA_PARAM_00: 0,
  DATA_PARAM_01: 1,
  DATA_PARAM_13: 19,
  DATA_PARAM_51: 81,
  DATA_PARAM_52: 82,
  DATA_PARAM_61: 97,
  DATA_PARAM_62: 98,
  DATA_PARAM_64: 100,
  DATA_PARAM_65: 101,
  DATA_PARAM_71: 113
};

/** 現在の処理判定 */
const CURRENT_PROCESS = {
  SHOW_RESULT: 0,
  SHOW_ERROR_FACTOR: 1
};

export default {
  name: 'requirement072',
  data() {
    return {
      phase: PHASE.IN_PROGRESS,
      isLoading: false,
      currentProcess: CURRENT_PROCESS.SHOW_RESULT,
      bodyItems: [],
      tableItems: [],
      resultData: {
        front: null,
        left: null,
        right: null,
        rear: null
      },
      columns: {
        front: this.$t(`individual.row_target_front`),
        left: this.$t(`individual.row_target_left`),
        right: this.$t(`individual.row_target_right`),
        rear: this.$t(`individual.row_target_rear`)
      },
      modal_requirement_072: false
    };
  },

  props: {
    workSupportId: { type: Number, default: '', required: true },
  },

  components: {
    'cstm-table': cstmTable
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),

    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.FAILED:
        case PHASE.ERROR:
        case PHASE.ERROR_COMMUNICATION:
        case PHASE.ERROR_FACTOR:
          return 'danger';
        case PHASE.RESULT:
        case PHASE.IN_PROGRESS:
        default:
          return 'secondary';
      }
    },

    systemTableColumns() {
      this.tableItems = [
        {
          name: 'itemName',
          label: `individual.label_table_item`
        },
        {
          name: 'itemValue',
          label: `individual.label_table_header_calibration_data`
        }
      ];
      return this.tableItems;
    }
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),

    /** 初期化処理 */
    init() {
      this.modal_requirement_072 = true;
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_requirement_072 = false;
    },

    /** その他エラー発生時の表示 */
    showUnexpectedError() {
      // 異常終了：エラー表示
      this.phase = PHASE.ERROR;
    },

    // 機能終了
    exit() {
      // 画面を閉じる
      this.closeWizard();

      // 初期設定に戻す
      this.phase = PHASE.IN_PROGRESS;
      this.currentProcess = CURRENT_PROCESS.SHOW_RESULT;
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
     */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    // 各API実行-------------------------------------------

    /** 画面起動時の起動処理 */
    async execute() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: 'start'
        };

        // 初期処理（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 成功
              // 停止処理に遷移
              await this.stop();
              break;
            case config.STATUS_WSP_FAILED:
              // 失敗
              // 各エラー表示
              switch (response.data.async_code) {
                case error.WSP_072_TAKEOVER_FAILURE:
                  // 引継ぎ失敗
                  this.phase = PHASE.FAILED;
                  break;
                case error.WSP_072_TAKEOVER_ERROR:
                  // 引継ぎエラー
                  this.currentProcess = CURRENT_PROCESS.SHOW_ERROR_FACTOR;
                  await this.read();
                  break;
                case error.WSP_072_COMMUNICATION_ERROR:
                  // 通信エラー
                  this.phase = PHASE.ERROR_COMMUNICATION;
                  break;
                default:
                  // 該当のエラーコードが存在しない場合、共通エラー
                  // ありえないが定義しておく
                  this.showUnexpectedError();
                  break;
              }
              break;
            default:
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 停止処理 */
    async stop() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: 'stop'
        };

        // 初期処理（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 成功
              this.currentProcess = CURRENT_PROCESS.SHOW_RESULT;
              // データ読出し実行
              await this.read();
              break;
            case config.STATUS_WSP_FAILED:
              // 失敗
              // 各エラー表示
              switch (response.data.async_code) {
                case error.WSP_072_TAKEOVER_ERROR:
                  // 引継ぎエラー
                  this.currentProcess = CURRENT_PROCESS.SHOW_ERROR_FACTOR;
                  // データ読出し実行
                  await this.read();
                  break;
                default:
                  // 該当のエラーコードが存在しない場合、共通エラー
                  // ありえないが定義しておく
                  this.showUnexpectedError();
                  break;
              }
              break;
            default:
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** データ読出し処理 */
    async read() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: 'read'
        };

        // 初期処理（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 取得データを割り当て
              this.resultData = {
                front: this.showContent(response.data.user_data.data_record.front),
                left: this.showContent(response.data.user_data.data_record.left),
                right: this.showContent(response.data.user_data.data_record.right),
                rear: this.showContent(response.data.user_data.data_record.rear)
              };
    
              // データセット
              this.setReadData();

              break;
            case config.STATUS_WSP_FAILED:
              switch (response.data.async_code) {
                case error.WSP_072_COMMUNICATION_ERROR:
                  // 通信エラー
                  this.phase = PHASE.ERROR_COMMUNICATION;
                  break;
                default:
                  // 該当のエラーコードが存在しない場合、共通エラー
                  // ありえないが定義しておく
                  this.showUnexpectedError();
                  break;
              }
              break;
            default:
              this.showUnexpectedError();
              return;
          }
        }

      } finally {
        this.isLoading = false;
      }
    },


    /** 終了処理 */
    async terminate() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: 'terminate'
        };

        await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

      } finally {
        this.isLoading = false;

        // 画面を閉じる
        this.closeWizard();

        // 初期設定に戻す
        this.phase = PHASE.IN_PROGRESS;
        this.currentProcess = CURRENT_PROCESS.SHOW_RESULT;
      }
    },

    // 表示内容の設定-------------------------------------------

    /**
     * データ読出し結果に対応する表示内容の設定
     * @param data_record バックエンドから受け取ったDataRecord
     * @returns テーブル表示内容
     * */
    showContent(data_record) {
      switch (data_record) {
        case DATA_RECORD.DATA_PARAM_00:
          // 0x00 (0)
          return this.$t(`individual.data_read_ws72_0x00`);
        case DATA_RECORD.DATA_PARAM_01:
          // 0x01 (1)
          return this.$t(`individual.data_read_ws72_0x01`);
        case DATA_RECORD.DATA_PARAM_13:
          // 0x13 (19)
          return this.$t(`individual.data_read_ws72_0x13`);
        case DATA_RECORD.DATA_PARAM_51:
          // 0x51 (81)
          return this.$t(`individual.data_read_ws72_0x51`);
        case DATA_RECORD.DATA_PARAM_52:
          // 0x52 (82)
          return this.$t(`individual.data_read_ws72_0x52`);
        case DATA_RECORD.DATA_PARAM_61:
          // 0x61 (97)
          return this.$t(`individual.data_read_ws72_0x61`);
        case DATA_RECORD.DATA_PARAM_62:
          // 0x62 (98)
          return this.$t(`individual.data_read_ws72_0x62`);
        case DATA_RECORD.DATA_PARAM_64:
          // 0x64 (100)
          return this.$t(`individual.data_read_ws72_0x64`);
        case DATA_RECORD.DATA_PARAM_65:
          // 0x65 (101)
          return this.$t(`individual.data_read_ws72_0x65`);
        case DATA_RECORD.DATA_PARAM_71:
          // 0x71 (113)
          return this.$t(`individual.data_read_ws72_0x71`);
        default:
          // 上記以外
          return this.$t(`individual.data_read_ws72_other`);
      }
    },

    /**
     * 引継ぎ結果表示 / 引継ぎエラー要因表示 に表示する内容をセット
     */
    setReadData() {

      // 引継ぎ結果表示 / 引継ぎエラー要因表示かを分ける
      if (this.currentProcess === CURRENT_PROCESS.SHOW_RESULT) {
        // 引継ぎ結果表示
        this.phase = PHASE.RESULT;
      } else {
        // 引継ぎエラー要因表示
        this.phase = PHASE.ERROR_FACTOR;
      }
      
      this.$nextTick(() => {
        // リスト表示項目の設定
        this.bodyItems = [
          {
            itemID: 0,
            itemName: this.columns.front,
            itemValue: this.resultData.front
          },
          {
            itemID: 1,
            itemName: this.columns.left,
            itemValue: this.resultData.left
          },
          {
            itemID: 2,
            itemName: this.columns.right,
            itemValue: this.resultData.right
          },
          {
            itemID: 3,
            itemName: this.columns.rear,
            itemValue: this.resultData.rear
          }
        ];
      });
    },

    // ユーザ操作-------------------------------------------

    /** 引継ぎ失敗表示画面 OK押下処理 */
    onFailedOkClicked() {
      this.stop();
    },

    /** 引継ぎ結果表示画面, 引継ぎエラー要因表示 OK押下処理 */
    onResultBackClicked() {
      this.exit();
    },

    /** 通信エラー画面 OK押下処理 */
    onCommunicationErrorOkClicked() {
      this.terminate();
    },

    /** エラー画面 OK押下処理 */
    onErrorOkClicked() {
      this.terminate();
    }
  },

  async mounted() {
    this.init();
    this.execute();
  }
};
